// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1UJkg","label":"styles_label__33FOk","input":"styles_input__2OUlm"};